import { Box } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';

import { Footer } from '../components/footer';
import { LoadingPage } from '../components/loading-page';
import { injectTSDI } from '../core/common/tsdi';
import { StudioStore } from '../core/studio-store';
import { ConfirmationPage } from './pages/confirmation';
import { Notification } from './pages/notification';
import { Summary } from './pages/summary';
import { MarketingConsentStore } from './store';

export const MarketingConsent = observer((): React.ReactElement => {
    const { legalLinks } = injectTSDI(StudioStore);
    const { dto, state, decline, confirm } = injectTSDI(MarketingConsentStore);
    const {
        pendingConsents,
        operatingCompanyName,
        studioName,
        communicationSettingsLink
    } = dto;

    const getContent = () => {
        switch (state) {
            case 'PENDING':
                return (
                    <ConfirmationPage
                        pendingConsents={pendingConsents || []}
                        studioName={studioName || ''}
                        operatingCompanyName={operatingCompanyName || ''}
                        onConfirm={confirm}
                        onDecline={decline}
                    />
                );
            case 'CONFIRMED':
            case 'DECLINED':
                return <Summary type={state} />;
            case 'ERROR':
            case 'NOT_FOUND':
                return (
                    <Notification
                        type={state}
                        link={communicationSettingsLink}
                    />
                );
            case 'FETCHING':
                return <LoadingPage />;
        }
    };

    return (
        <Box display="flex" flexDirection="column" height="calc(100vh - 10px)">
            {getContent()}
            <Footer
                legalLinks={legalLinks.result}
                studioName={studioName}
                renderLogo
            />
        </Box>
    );
});
